import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { Spinner } from "react-bootstrap";

import BreadCrumb from "../../BreadCrumb";

import { useParams } from "react-router-dom";
import { useHistory } from "react-router-dom";
import {
  addContact,
  editContact,
  editGeneral,
  updateContact,
  updateGeneral,
} from "../../../store/actions/councilActions/contactActions";

const breadcrumbs = [
  {
    path: "/admin/dashboard",
    label: "Dashboard",
  },
  {
    label: "Add Contact",
  },
];

const EditHelpline = () => {
  const [loading, setLoading] = useState(false);
  const [exist, setExist] = useState(true);
  const history = useHistory();
  const dispatch = useDispatch();
  const { id } = useParams();

  const initialState = {
    mobile: "",
  };
  const [data, setData] = useState(initialState);
  const fetchData = async () => {
    setLoading(true);
    const response = await dispatch(editGeneral(id));
    if (response) {
      setData({
        mobile: response.mobile,
      });
      setLoading(false);
    } else {
      setLoading(false);
      setExist(false);
    }
  };
  useEffect(() => {
    if (id) {
      fetchData();
    }
  }, []);
  const handleChange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };

  const { mobile } = data;
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (id) {
      const response = await dispatch(
        updateGeneral({
          ...data,
          helpline_id: id,
        })
      );
      if (response) {
        setData(initialState);
        history.push("/admin/contact/list");
      }
    }
  };
  return (
    <div className="row">
      <div class="content d-flex flex-column flex-column-fluid" id="kt_content">
        <div class="subheader py-2 py-lg-6 subheader-solid" id="kt_subheader">
          <div class="container-fluid d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
            <BreadCrumb crumbs={breadcrumbs} />

            <div class="d-flex align-items-center">
              <Link
                to="/admin/contact/list"
                class="btn btn-light-primary font-weight-bolder btn-sm"
              >
                Contact List
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-8 card">
          {loading ? (
            <div className="text-center">
              <Spinner animation="border" role="status" size="lg">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </div>
          ) : exist ? (
            <>
              <div className="card-header text-center">{"Edit Helpline"}</div>
              <div class="myForm">
                <form onSubmit={handleSubmit}>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="boxlabel">
                            <p>Phone</p>
                            <input
                              type="text"
                              name="mobile"
                              value={mobile}
                              onChange={handleChange}
                              class="form-control"
                              required
                            />
                          </div>
                        </div>

                        <div class="col-md-12">
                          <div
                            class="btn-groups mt-4 text-right"
                            role="group"
                            aria-label="First group"
                          >
                            <button class="btn btn-Next" type="submit">
                              Submit<span></span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </>
          ) : (
            <h5>No Record Found</h5>
          )}
        </div>
      </div>
    </div>
  );
};

export default EditHelpline;
